import { useSort } from 'store/sort';
import { useSearch } from 'store/search';
import { useCatalogPagination } from 'store/pagination';
import { useFilters } from 'store/filters';
import { useShallow } from 'zustand/react/shallow';

const useCatalogParams = () => {
  const sort = useSort(
    useShallow((state) => ({
      sortParam: state.sort.value,
      setSort: state.setSort,
    })),
  );

  const search = useSearch(
    useShallow((state) => ({
      searchParam: state.search,
      setSearch: state.setSearch,
    })),
  );

  const pagination = useCatalogPagination(
    useShallow((state) => ({
      paginationParam: state.pagination,
      limit: state.pageLimit,
      setPagination: state.setPagination,
    })),
  );

  const filters = useFilters(
    useShallow((state) => ({
      fullLightWeightParam: state.filters.full_light_weight,
      tradeOfferTypeParam: state.filters.trade_offer_type,
      colorMetalParam: state.filters.color_metal,
      materialParam: state.filters.material,
      forwhomParam: state.filters.forwhom,
      storeParam: state.filters.store,
      probParam: state.filters.prob,
      categoryParam: state.filters.category,
      subcategoryParam: state.filters.subcategory,
      sizeParam: state.filters.size,
      vstavkiParam: state.filters.vstavki,
      vstavkiDetailParam: state.filters.vstavkidetail,
      minWeightParam: state.filters.minWeight,
      maxWeightParam: state.filters.maxWeight,
      minPriceParam: state.filters.minPrice,
      maxPriceParam: state.filters.maxPrice,
    })),
  );

  const setFilters = useFilters((state) => state.setFilters);

  return { sort, search, pagination, filters, setFilters };
};

export { useCatalogParams };
